import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getStatus } from "../../../../components/columns/get-status";
import BybestCustomerLayout, {
  customerText,
} from "../../../../components/Seo/whitelabel/bybest/bybest-customer-layout";
import GenericTable from "../../../../components/Table/generic-table";
import ChatModal from "../../chat/chat-modal";
import CustomerHeader from "../../customer-header";
import { chatIcon, trackIcon } from "../icons";
import { orderDetailsColumn, orderDetailsData } from "./../columns";
import "./index.css";
import Subtotal from "./subtotal";

const OrderDetails = () => {
  const { orderId } = useParams();
  const { state } = useLocation();

  const [open, setOpen] = useState(false);

  return (
    <BybestCustomerLayout>
      <div className="flex flex-1 flex-col mt-6">
        <div className="w-full boxshadow border-[1px] border-[#EAECF0] rounded-lg">
          <div className="grid md:flex justify-between items-center w-full border p-6">
            <CustomerHeader
              description="June 27, 2024 2:10 AM"
              title={`${customerText("order")} #${orderId}`}
              showItems={false}
            />
            <div className="flex flex-col gap-5 items-start md:items-end w-full">
              <div className="status-card">
                <span>{customerText("status")}: </span>
                <span>{getStatus(state?.status)}</span>
              </div>

              <div className="flex items-center gap-2">
                <div className="status-card cursor-pointer">
                  <span>{trackIcon}</span>
                  <span>{customerText("trackOrder")}</span>
                </div>
                <div
                  className="status-card cursor-pointer"
                  onClick={() => setOpen(true)}
                >
                  <span>{chatIcon}</span>
                  <span>{customerText("chatNow")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-6">
            <div className="text-[#101828] text-18 font-semibold leading-7">
              {customerText("address")}
            </div>
          </div>

          <div className="bg-[#FAFAFA] p-6">
            <div className="bg-white p-6 rounded-[12px]">
              <div className="text-[#101828] text-18 font-semibold leading-7">
                <div className="flex flex-col gap-1">
                  <span>Megi Skendaj,</span>
                  <span>Tirane, Tirane, 1001,</span>
                  <span>slemdaj.megi@gmail.com</span>
                  <span>+35569324235</span>
                </div>
              </div>
            </div>
          </div>

          <div className="p-6 flex flex-col gap-5">
            <GenericTable
              columns={orderDetailsColumn}
              data={orderDetailsData}
              className="w-full md:block pr-4"
              showPagination={false}
            />
            <div className="grid grid-cols-1 md:grid-cols-3 w-full bg-white">
              <div className="hidden md:block md:col-span-2"></div>
              <div className="flex flex-col gap-5">
                <Subtotal />
                <hr className="border-[1px]  border-[#E5E7EB]" />
                <div className="subtotal-wrapper">
                  <p>{customerText("total")}</p>
                  <p>8300.00 LEK</p>
                </div>
                <hr className="border-[1px]  border-[#E5E7EB]" />
                <div className="subtotal-wrapper">
                  <span>
                    {customerText("exchangeRate")} (EUR{">"}ALL)
                  </span>
                  <p>106</p>
                </div>
                <div className="subtotal-wrapper">
                  <span>{customerText("paymentMethod")}</span>
                  <p>Cash</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ChatModal handleClose={() => setOpen(false)} open={open} />
    </BybestCustomerLayout>
  );
};

export default OrderDetails;
